import * as actions from "./actionsTypes";

const initialData = {
  loaderCompetencie: false,
  loaderCompetencies: false,
  saveLoaderCompetencie: false,
  competencies: null,
  competencie: null,
  competenciesFaild: null,
  competencieFaild: null,
  formcompetencieFaild: null  
};

export default function competenciesReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_COMPETENCIE:
      return { ...state, loaderCompetencie: action.payload };
    case actions.LOADING_COMPETENCIES:
      return { ...state, loaderCompetencies: action.payload };
    case actions.SAVE_LOADING_COMPETENCIES:
      return { ...state, saveLoaderCompetencie: action.payload };
    case actions.GET_COMPETENCIE:
      return { ...state, competencie: action.payload };
    case actions.GET_COMPETENCIES:
      return { ...state, competencies: action.payload };
    case actions.COMPETENCIE_FAIL:
      return { ...state, competencieFaild: action.payload }
    case actions.COMPETENCIES_FAIL:
      return { ...state, competenciesFaild: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formcompetencieFaild: action.payload };
    default:
      return state;
  }
}
